import {useState} from 'react';
import {PageHeader} from '@/components/molecules';
import {LabelWithoutJson} from '@/components/atoms';
import {RackCatalogList} from '@/containers/RackCatalog/RackCatalogList';
import {FONT_SIZE, FONT_WEIGHT} from '@/utils/constants/globalStyle';
import {COLOR_CODE} from '@/utils/constants/colors';
import {useRackCatalog} from '@/hooks/useRackCatalog';
import PropTypes from 'prop-types';
import AddRackModal from './AddRackModal';
import ViewRackModal from './ViewRackModal';
import EditRackModal from './EditRackModal';
import './rackCatalogHome.scss';

const RackCatalogHome = ({instanceKey}) => {
  const [showAddRack, setShowAddRack] = useState(false);
  const [viewRack, setViewRack] = useState(null);
  const [editRack, setEditRack] = useState(null);
  const [publishMessage, setPublishMessage] = useState('');
  const {totalRacks, lastUpdated} = useRackCatalog();

  const handleAddNewRack = () => {
    setPublishMessage('');
    setShowAddRack(true);
  };

  const handleViewMore = (rack) => {
    setPublishMessage('');
    setViewRack(rack);
  };

  const handleEditFromView = (rack) => {
    setViewRack(null);
    setEditRack(rack);
  };

  const handleEditClose = () => {
    setEditRack(null);
  };

  const handleEditSaved = () => {
    setEditRack(null);
    setPublishMessage('Rack updated successfully.');
  };

  return (
    <div
      key={instanceKey}
      className='rackCatalogContainer flex flex-col'
      data-testid='rack-catalog-home'>
      <PageHeader title='Rack Catalog' />
      {publishMessage && <p role='status'>{publishMessage}</p>}
      <div className='rackCatalogInfoSection'>
        {lastUpdated && (
          <>
            <LabelWithoutJson
              id='rack-catalog-last-updated'
              text={`Last Updated: ${lastUpdated}`}
              fontSize={FONT_SIZE.SM}
              fontWeight={FONT_WEIGHT.NORMAL}
              color={COLOR_CODE._EFEFEF}
            />
            <span className='rackCatalogInfoDivider'>|</span>
          </>
        )}
        <LabelWithoutJson
          id='rack-catalog-total-racks'
          text={`Total Racks: ${totalRacks}`}
          fontSize={FONT_SIZE.SM}
          fontWeight={FONT_WEIGHT.NORMAL}
          color={COLOR_CODE._EFEFEF}
        />
      </div>

      <RackCatalogList
        onAddNewRack={handleAddNewRack}
        onViewMore={handleViewMore}
      />

      {showAddRack && (
        <AddRackModal
          onClose={() => setShowAddRack(false)}
          onPublished={() => setShowAddRack(false)}
        />
      )}

      {viewRack && (
        <ViewRackModal
          rack={viewRack}
          onClose={() => setViewRack(null)}
          onEdit={handleEditFromView}
        />
      )}

      {editRack && (
        <EditRackModal
          rack={editRack}
          onClose={handleEditClose}
          onSaved={handleEditSaved}
        />
      )}
    </div>
  );
};

RackCatalogHome.propTypes = {
  instanceKey: PropTypes.string.isRequired
};

export default RackCatalogHome;
